import React from 'react';
import PropTypes from 'prop-types';

import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';
import pluralize from 'pluralize';

const SrUtilitySetupDownloadUtilityDocs = ({
  note,
  filesCount,
  utilityPartnerName,
  onDownload,
}) => {
  return (
    <SrBox bgColor="blueLight800" padding="16px 6px" borderRadius="8px">
      <SrText
        font="greycliff"
        weight="800"
        fontSize="16px"
        align="center"
        display="block"
        color="blue200"
        lineHeight="19px"
      >
        Send proof docs to utility company
      </SrText>
      {note && (
        <SrBox marginTop="7px">
          <SrText
            className="pretty"
            font="greycliff"
            weight="600"
            fontSize="14px"
            align="center"
            display="block"
            lineHeight="20px"
          >
            "{note}"
          </SrText>
        </SrBox>
      )}
      <SrBox
        display="flex"
        justifyContent="center"
        alignItems="center"
        flexDirection="column"
        marginTop="12px"
      >
        <SrText
          font="greycliff"
          weight="700"
          fontSize="16px"
          align="center"
          display="block"
          color="blue300"
          decoration="underline"
          lineHeight="20px"
          cursor="pointer"
          onClick={onDownload}
        >
          Download ({pluralize('file', filesCount, true)})
        </SrText>
        <SrText
          font="greycliff"
          weight="700"
          fontSize="10px"
          align="center"
          display="block"
          fontStyle="italic"
        >
          Uploaded by {utilityPartnerName}
        </SrText>
      </SrBox>
    </SrBox>
  );
};

SrUtilitySetupDownloadUtilityDocs.propTypes = {
  note: PropTypes.string,
  filesCount: PropTypes.number.isRequired,
  utilityPartnerName: PropTypes.string.isRequired,
  onDownload: PropTypes.func.isRequired,
};

SrUtilitySetupDownloadUtilityDocs.displayName = 'SrUtilitySetupDownloadUtilityDocs';

export default SrUtilitySetupDownloadUtilityDocs;
